module.exports = __webpack_public_path__ + "static/BL001-42c604101633923ceee557d110957df1.svg";